import React from 'react';
import { connect } from 'react-redux'

class Breadcrumb extends React.Component {
	render(props) {
		return (
		/*<div class="row breadcrumb-area">
			<ol class="breadcrumb breadcrumb-ast">
			  <li>{this.props.application.breadcrumb}</li>
			</ol>
		</div>*/
		<div/>
		);
	}
}


const mapStateToProps = (state) => {
  return {
    application: state.application
  }
}

function mapDispatchToProps(dispatch) {
  return ({
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumb)